import { deleteTenant } from '@infuse/api/iam/tenant';
import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useDeleteTenant = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  const mutation = useMutation<unknown, unknown, string>({
    mutationFn: async (tenantId: string) => {
      try {
        await deleteTenant({ id: tenantId });
        notify({
          title: t('iam.tenants.header.delete_tenant'),
          message: t('iam.tenants.notify.delete_tenant_success')
        });
      } catch (e) {
        notify({
          type: UiNotificationType.ERROR,
          title: t('iam.tenants.header.delete_tenant'),
          message: getAxiosErrorMessage(e, t('iam.tenants.notify.delete_tenant_failed'))
        });
        throw e;
      }
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    }
  });

  return {
    ...mutation
  };
};
